import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://julihe.falcon-studio.top',
  baseURL: 'http://admin.julihe.com/',
  timeout: 10000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    Toast.loading({ message: '加载中...' })
    if (config.method === 'post') {
      config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
      config.data = config.data || {}
      // if (process.env.NODE_ENV === 'production') {
      //   // config.data.token = getToken()
      // } else {
      //   config.data.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIiwianRpIjoid2F3YXR1YW4ifQ.eyJpc3MiOiJ3YXdhdHVhbiIsImF1ZCI6ImFwcCIsImp0aSI6Indhd2F0dWFuIiwiaWF0IjoxNTYwMTU3NDkzLCJuYmYiOjE1NjAxNTc0OTMsImV4cCI6MTg3NTUxNzQ5MywidWlkIjozOH0.'
      // }
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    setTimeout(() => {
      Toast.clear()
    }, 300)
    return response.data
  },
  error => {
    Toast.fail(error.msg)
    return 'err'
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js